import { getChatSession } from './getChatSession'
import { saveChatSession } from './saveChatSession'

/**
 *
 * @param {ChatSessionMessage} message
 */
export function saveChatMessageToSession(message) {
  const session = getChatSession()
  session.conversation.push(message)
  saveChatSession(session)
}
